import { getUser } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const useSWRUser = (userId: string | null) => {
  const {
    data: user,
    isLoading,
    error,
    mutate,
  } = useSWRImmutable(userId ? `user-${userId}` : null, () => getUser(userId as string));

  return {
    user,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRUser;
